import { Component, OnInit, Input } from '@angular/core';
import { DataTableEventsService } from '../../services/datatable.events.service';

@Component({
  selector: 'lib-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class TableBreadcrumbComponent implements OnInit {

  @Input() params: any;

  breadcrumb = [];

  constructor(
    private tableEventsHandler: DataTableEventsService
  ) { }

  ngOnInit() { }

  goToLevel(level: any) {
    this.tableEventsHandler.breadcrumbClicked.next(level);
  }
}
